import React, { useEffect, useState } from "react";
import { Loading } from "../../../components";
import usePastWellnessPlans from "../../../services/wellness-plans-past/wellness-plans-past.service";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import PastPlanCard from "./PastPlanCard";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { PastWellnessPlanMembership } from "../../../services/wellness-plans-past/wellness-plans-past.interface";

const PastPlansContainer = () => {
  const { pastWellnessPlans, getPastWellnessPlans, loading } = usePastWellnessPlans();
  const [pastPlans, setPastPlans] = useState<Record<string, string>[]>([]);
  const { petList } = usePetStore();


  useEffect(() => {
    getPastWellnessPlans();
    userActivityLogger(MIXPANEL_EVENTS.USER_CLICKS_PAST_PLANS, {});
  }, []);


  useEffect(() => {
    if (pastWellnessPlans && petList) {
      const pastPlans = petList
        .filter((pet: any) =>
          pastWellnessPlans.some((plan: PastWellnessPlanMembership) => plan.animal_id === pet.id),
        )
        .map((pet: any) => {
          return {
            id: pet.id,
            image: pet.image,
            name: pet.name,
            endDate: pastWellnessPlans.find((plan: any) => plan.animal_id === pet.id)?.endDate || "",
            planName: pastWellnessPlans.find((plan: any) => plan.animal_id === pet.id)?.planName || "",
          };
        });

      setPastPlans(pastPlans);
    }
  }, [pastWellnessPlans, petList]);


  if (loading) {
    return <Loading />;
  }

  if (pastWellnessPlans.length === 0 || pastPlans.length === 0) {
    return (
      <div className="flex justify-center cursor-default">
        <div className="w-full max-w-[528px] flex flex-col items-center gap-2">
          <div>
            <img src="/assets/icons/no_pasts_plans.png" className="mx-auto" alt="Not found Image" />
            <p className="text-center text-sm">It looks like you don&apos;t have any past wellness plans.
               If this isn&apos;t the case, please contact your local GoodVets hospital.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center cursor-default">
      <div className="w-full max-w-[528px] flex flex-col items-center gap-2">
        <div className="text-sm font-semibold my-1 self-start">Your Past Plans</div>
        {pastPlans?.length > 0 && pastPlans.map((pet: any) =>(
          <PastPlanCard
            key={pet.id}
            petId={pet.id}
            petImage={pet.image}
            petName={pet.name}
            planName={pet.planName}
            endDate={pet.endDate} />))}
      </div>
    </div>
  );
};

export default PastPlansContainer;
